export const TOP_SELLING_PRODUCTS = 'TOP_SELLING_PRODUCTS';
